export default "__VITE_ASSET__3b4b7eb5__"